"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const config_1 = require("../../config/config");
const styles = (theme) => (0, styles_1.createStyles)({
    dialogBackdrop: {
        backgroundColor: color(theme.palette.grey[500]).alpha(0.8).rgb().string()
    },
    dialog: {
        backgroundColor: theme.palette.background.default,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    dialogContent: {
        padding: 0
    },
    dialogActions: {
        marginBottom: theme.spacing(3)
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    error: {
        color: theme.palette.error.main,
        fontSize: 70,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    warning: {
        color: config_1.config.themeColors.warningColor.hex(),
        fontSize: 70,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
});
exports.default = styles;
//# sourceMappingURL=MessagePopupStyle.js.map